const Row = ({ children, className = '', justify = '', align = '', ...props }) => (
  <div
    {...props}
    className={`${className || ''} row${align ? ` align-items-${align}` : ''}${justify ? ` justify-content-${justify}` : ''}`}>
    {children}
  </div>
)

export default Row
